import React from "react";

import {borderColour} from "../../../../style/styleConsts";
import {Tooltip} from "antd";
import {createVolumeTooltip} from "./tooltipFactory";
import {OriginBar} from "./OriginBar";

export const VolumeChart = (props) => {
    if (isNaN(props.volumeChange) || props.volumeChange === Infinity) {
        return <div className="t-volume-container"/>;
    }
    const describeVolumeChangeOverTimePeriod = createVolumeTooltip(props.timePeriodName);
    return <Tooltip title={describeVolumeChangeOverTimePeriod(props.averageVolume, props.currentVolume)}
                    mouseLeaveDelay={0}>
        <div className="t-volume-container"
             style={{width: 100, height: 10, position: "relative", display: "flex"}}>
            <OriginBar/>
            <div style={{width: "50%"}}>
                {props.volumeChange < 0 ? <div className="t-volume" style={{
                    transition:      "width 0.3s",
                    width:           Math.min(100, -100 * props.volumeChange / 25).toFixed() + "%",
                    height:          10,
                    backgroundColor: borderColour,
                    float:           "right"
                }}/> : null}
            </div>
            <div style={{width: "50%"}}>
                {props.volumeChange > 0 ? <div className="t-volume" style={{
                    transition:      "width 0.3s",
                    width:           Math.min(100, 100 * props.volumeChange / 25).toFixed() + "%",
                    height:          10,
                    backgroundColor: borderColour
                }}/> : null}
            </div>
        </div>
    </Tooltip>
};